import {Text} from '#component/base';

import {CTACardWide} from './CTACardWide';

import {CTACardWideProps} from './CTACardWide.types';

import {
  CTACardWideInnerWrapperContentSecondaryTextPurchaseATestLede,
  CTACardWideWrapperBgPurchaseATest,
  CTACardWideWrapperBgReferral,
  CTACardWideWrapperBgUpgradeAllProducts,
  upgradeToMembershipCardList,
  upgradeToMembershipCardListWrapper,
} from './CTACardWide.css';

export const ReferralCardRow = (props: CTACardWideProps) => (
  <CTACardWide
    headline="Give $30, Get $30"
    href="/shop/pages/referrals"
    hasOverlay={false}
    lede="Longevity loves company. Refer a friend and you'll both receive a $30 credit towards your next order."
    className={CTACardWideWrapperBgReferral}
    variants="entireRow"
    {...props}
  />
);

export const PurchaseATestCard = (props: CTACardWideProps) => (
  <CTACardWide
    headline="Purchase a Test"
    href={props.href}
    lede={<LedePurchaseATest />}
    textColor="white"
    hasOverlay={false}
    className={CTACardWideWrapperBgPurchaseATest}
    variants="textBottom"
    btnText="Shop Now"
  />
);
const LedePurchaseATest = () => (
  <Text
    as="p"
    variant="body"
    color="white"
    className={CTACardWideInnerWrapperContentSecondaryTextPurchaseATestLede}>
    {`The TallyAge Test is a next-generation, epigenetic aging clock trained to predict epigenetic age from a painless cheek swab.`}
  </Text>
);

export const UpgradeAllProductsCardWide = () => (
  <CTACardWide
    headline="The future of healthy aging"
    href="/shop/collections"
    lede="Take control over how you age. Unlock healthier years with science-backed tools designed to improve your healthspan and longevity."
    textColor="white"
    hasOverlay={false}
    className={CTACardWideWrapperBgUpgradeAllProducts}
    variants="textLeft"
    btnText="Shop Now"
  />
);

const UpgradeToMembershipCardList = () => (
  <Text as="ul" className={upgradeToMembershipCardList}>
    <li>
      <Text color="white">TallyAge™ Tests</Text>
    </li>
    <li>
      <Text color="white">Personalized Action Plans</Text>
    </li>
    <li>
      <Text color="white">Longevity Supplements</Text>
    </li>
  </Text>
);

export const UpgradeToMembershipCardWide = () => (
  <CTACardWide
    headline="Upgrade to Membership"
    imageUrl="/image/profile/hero-cta-upgrade-to-membership.png"
    lede={<UpgradeToMembershipCardList />}
    variants="burgundyBackground"
    btnText="Upgrade Now"
    className={upgradeToMembershipCardListWrapper}
    imagePosition="right"
    href="/profile?tab=manage"
  />
);
